import { useCallback } from 'react';
import { useHubSpotAppLinkHandler } from '../context/HubSpotAppLinkHandlerContext';
import { trackLinkNavigation } from '../../record/internal/Metrics';
import { Link } from 'foundations-components/transitional/components/Link';
import GenericLink from '../../record/internal/GenericLink';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HubSpotAppLink({
  children,
  LinkComponent = Link,
  LinkComponentProps = {},
  linkType,
  linkTypeProps,
  onTrackClick
}) {
  var _linkHandler$external;
  const linkHandler = useHubSpotAppLinkHandler(linkType);
  const onClick = useCallback(event => {
    var _LinkComponentProps$e;
    if (onTrackClick) {
      onTrackClick(Object.assign({}, linkTypeProps, {
        event
      }));
    }
    if (linkHandler.onClick) {
      linkHandler.onClick(linkTypeProps, event);
    }
    trackLinkNavigation({
      linkType,
      linkTypeProps,
      external: (_LinkComponentProps$e = LinkComponentProps === null || LinkComponentProps === void 0 ? void 0 : LinkComponentProps.external) !== null && _LinkComponentProps$e !== void 0 ? _LinkComponentProps$e : false
    });
  }, [onTrackClick, linkHandler, linkType, linkTypeProps, LinkComponentProps === null || LinkComponentProps === void 0 ? void 0 : LinkComponentProps.external]);
  return /*#__PURE__*/_jsx(GenericLink, {
    dataSpeculationTarget: `crm-links-${linkType}`,
    external: (_linkHandler$external = linkHandler.external) !== null && _linkHandler$external !== void 0 ? _linkHandler$external : false,
    href: linkHandler.getHref(linkTypeProps),
    LinkComponent: LinkComponent,
    LinkComponentProps: LinkComponentProps,
    onClick: onClick,
    children: children
  });
}